// export const getAccessToken = () => {
//     return sessionStorage.getItem("token");
//   };
  
//   export const setAccessToken = (AccessToken) => {
//     sessionStorage.setItem("token", AccessToken);
//   };
  
//   export const removeAccessToken = () => {
//     sessionStorage.removeItem("token");
//   };

export const getAccessToken = () => {
    return localStorage.getItem("token");
  };
  
  export const setAccessToken = (AccessToken) => {
    localStorage.setItem("token", AccessToken);
  };
  
  export const removeAccessToken = () => {
    localStorage.removeItem("token");
  };

  